export const projectMetadataOptions = {
  projectTypes: [
    "Industrial Process",
    "Transportation System",
    "Energy Generation",
    "Manufacturing",
    "Construction",
    "Software System",
    "Medical System",
    "Infrastructure",
  ],
  lifecycles: [
    "Deployment",
    "Build",
    "Construction",
    "Installation",
    "Testing",
    "Operational",
    "Decommissioning",
  ],
  locationTypes: [
    "Indoor Controlled",
    "Indoor Industrial",
    "Outdoor Urban",
    "Outdoor Rural",
    "Marine Environment",
    "Underground",
    "High Altitude",
    "Extreme Weather",
  ],
  operatingConditions: [
    "Temperature Extremes",
    "High Humidity",
    "Corrosive Environment",
    "Dust/Particulates",
    "Electromagnetic Fields",
    "Vibration",
    "Noise",
    "Chemical Exposure",
  ],
  userTypes: [
    "Single Member",
    "Public",
    "Operators",
    "Maintainer",
    "Constructor",
    "Installer",
  ],
};
